export default __webpack_public_path__ + "static/media/pwaQrCode.b15ee6eb.png";